define(['jquery', 'masonry', 'imagesLoaded', 'jquery.history', 'ajaxrequesttracker'], function ($, Masonry, imagesLoaded) {

    var itemguid = $("#secondaryMenu").attr("data-guid");
    var publicationResults = new Array();
    var newsResults = new Array();
    var eventsResults = new Array();
    var publicationPage = 1;
    var newsPage = 1;
    var eventPage = 1;
    var sortField = "title";
    var currentProfessionalsPage = 1;
    var professionalsPageCount = parseInt($("#hiddenPageCount").text());
    var professionalResults = new Array();
    var rebindExpandCollapse = false;
    var manualStateChange = false;
    var ajax;

    LoadContent();

    (function (window, undefined) {
        // Define variables
        var History = window.History,
            State = History.getState();

        // Bind statechange event
        History.Adapter.bind(window, 'statechange', function () {
            var State = History.getState();
            if (manualStateChange == true) {
                LoadContent(decodeURIComponent(State.data.tab));
                $('.nav__link.is-active').trigger('mouseover');
            }
            manualStateChange = true;
        });

    })(window)

    $(".secondary-tabs .nav__item .nav__link").click(function (e) {
        e.preventDefault();
        var url = [location.protocol, '//', location.host, location.pathname].join('');
        var tab = $(this).text();
        var tabName = $(this).attr("data-tabname");
        var tabIndex = $(this).attr("data-tabindex");
        UpdateTitleTag(decodeURIComponent(tab));
        manualStateChange = true;
        History.pushState({ tab: tabIndex }, $("head title").text(), "?tab=" + encodeURIComponent(tabName));

    });

    function LoadContent() {
        $(".secondary-tabs .nav__link").removeClass("is-active");
        var queryString = window.location.search;
        queryString = queryString.substring(1);
        var params = queryString.split("&");
        var tab;
        for (i = 0; i < params.length; i++) {
            var temp = params[i].split("=");
            tab = temp[1];
        }
        var currentTab;
        if (tab === undefined)
            currentTab = $(".secondary-tabs .nav__link")[0];
        else
            currentTab = $(".secondary-tabs").find('[data-tabname="' + decodeURIComponent(tab) + '"]');

        $(".tabs__label").text($(currentTab).text());
        UpdateTitleTag($(currentTab).text());
        $(currentTab).addClass("is-active");
        var index = $(currentTab).attr("data-tabindex");
        LoadTab(index);
    }

    function LoadTab(index) {
        $(".loading-image").show();
        $(".site-main.site-main--interior").hide();
        $(".site-footer").hide();

        if (index == "1") {
            ajaxUrl = "/Layouts/WebUserControls/Main/Offices/tabs/AjaxLoadProfessionals.aspx?officeGuid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main.col--main--reverse").html(p);
                currentProfessionalsPage = 1;
                BindAttorneyFilters();
                LoadProfessionals();
            });
        }
        else if (index == "2") {
            ajaxUrl = "/Layouts/WebUserControls/Main/Offices/tabs/AjaxLoadInsights.aspx?officeGuid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main.col--main--reverse").html(p);
                publicationPage = 1;
                eventPage = 1;
                LoadPublications();
                LoadUpcomingEvents();
                LoadRecentEvents();

                $(".js-accordion-trigger.publications").click(function () {
                    LoadPublications();
                });
                $(".js-accordion-trigger.recent-events").click(function () {
                    LoadRecentEvents();
                });
            });
        }
        else if (index == "3") {
            ajaxUrl = "/Layouts/WebUserControls/Main/Offices/tabs/AjaxLoadNews.aspx?officeGuid=" + itemguid;
            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main.col--main--reverse").html(p);
                newsPage = 1;
                LoadNews();

                $(".js-accordion-trigger.news").click(function () {
                    LoadNews();
                });
            });
        }
        else {
            ajaxUrl = "/Layouts/WebUserControls/Main/Offices/tabs/AjaxLoadFactSheet.aspx?officeGuid=" + itemguid;

            $.ajax({ url: ajaxUrl }).done(function (p) {
                $(".tab-wrapper.col--main.col--main--reverse").html(p);
                $(".site-main.site-main--interior").fadeIn('slow');
                $(".site-footer").fadeIn('slow');
                $(".loading-image").hide();
            });
        }
    }

    function LoadPublications() {
        var publicationPageSize = parseInt($(".js-accordion-trigger.publications").attr("data-page-size"));

        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedPublications",
            data: JSON.stringify({ entityGuid: itemguid, startPage: publicationPage, pageSize: publicationPageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                publicationResults = response.d;

                if (publicationResults.length == 0 && publicationPage == 1) {
                    $(".mod.mod-insights.publications").hide();
                    return;
                }

                if (publicationResults.length <= publicationPageSize)
                    $(".js-accordion-trigger.publications").hide();
                else
                    publicationResults.pop();       //get arid of last result it was just to check if there were more

                RecursiveLoadListItems(0, publicationResults, $(".mod.mod-insights.publications .articles-list"))

                $(".mod.mod-insights.publications").show();

                publicationPage = publicationPage + 1;
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadNews() {
        var newsPageSize = parseInt($(".js-accordion-trigger.news").attr("data-page-size"));

        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedNews",
            data: JSON.stringify({ entityGuid: itemguid, startPage: newsPage, pageSize: newsPageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                newsResults = response.d;
                if (newsResults.length == 0 && newsPage == 1) {
                    $(".mod.mod-news").hide();
                    return;
                }
                if (newsResults.length <= newsPageSize)
                    $(".js-accordion-trigger.news").hide();
                else
                    newsResults.pop();       //get arid of last result it was just to check if there were more

                RecursiveLoadListItems(0, newsResults, $(".mod.mod-news .articles-list"));
                newsPage = newsPage + 1;
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadUpcomingEvents() {
        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedUpcomingEventsNew",
            data: JSON.stringify({ entityGuid: itemguid }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                eventsResults = response.d;
                var currentUpcoming = $(".upcoming .articles-list li").length;
                if (eventsResults.length == 0 && eventPage == 1 && currentUpcoming == 0) {
                    $(".mod.mod-events .upcoming").hide();
                    return;
                }

                RecursiveLoadListItems(0, eventsResults, $(".mod.mod-events .upcoming .articles-list"), true);
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadRecentEvents() {
        var eventsPageSize = parseInt($(".js-accordion-trigger.recent-events").attr("data-page-size"));
        $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Insights/InsightSearchService.asmx/GetRelatedRecentEvents",
            data: JSON.stringify({ entityGuid: itemguid, startPage: eventPage, pageSize: eventsPageSize + 1 }), //add 1 so we can tell if there are more to load
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                eventsResults = response.d;
                if (eventsResults.length == 0 && eventPage == 1) {
                    $(".mod.mod-events .recent").hide();
                    return;
                }
                if (eventsResults.length <= eventsPageSize)
                    $(".js-accordion-trigger.recent-events").hide();
                else
                    eventsResults.pop();       //get arid of last result it was just to check if there were more

                RecursiveLoadListItems(0, eventsResults, $(".mod.mod-events .recent .articles-list"), true);
                eventPage = eventPage + 1;
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadProfessionals() {
        if (currentProfessionalsPage == 1)
            $(".listing.professional-results").html("");

        professionalsPageCount = parseInt($("#hiddenPageCount").text());

        ajax = $.ajax({
            type: "POST",
            url: "/Layouts/WebUserControls/Main/Professionals/ProfessionalsSearchService.asmx/GetRelatedLawyers",
            data: JSON.stringify({ entityGuid: itemguid, startPage: currentProfessionalsPage, pageSize: professionalsPageCount + 1, sortDirection: sortField }),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            beforeSend: function () {
                if (ajax != null) {
                    $.ajaxQ.abortAll();
                }
            },
            success: function (response) {
                professionalResults = response.d;
                professionalsPageCount = parseInt($("#hiddenPageCount").text());
                LoadProfressionalItems();
            },
            error: function (xhr, ajaxOptions, thrownError) {

            }
        });
    }

    function LoadProfressionalItems() {
        $(".filtering.filtering--result-stat").show();

        if (professionalResults.length == 0) {
            return;
        }

        if (professionalResults.length <= professionalsPageCount)
            $(".btn-accordion.professional").hide();
        else {
            $(".btn-accordion.professional").show();
            professionalResults.pop();       //get arid of last result it was just to check if there were more
        }

        RunRecursiveAjaxCalls(0);
        currentProfessionalsPage++;
    }

    function RunRecursiveAjaxCalls(i) {
        if (i >= professionalResults.length) {
            $(".site-main.site-main--interior").fadeIn('slow');
            $(".site-footer").fadeIn('slow');
            $(".loading-image").hide();
            return;
        }

        var ajaxUrl = "/Layouts/WebUserControls/Main/Professionals/AjaxLoadListItem.aspx?guid=" + professionalResults[i];
        var loading = false;

        $.ajax({ url: ajaxUrl })
            .done(function (p) {
                $(".listing.professional-results").append(p);
                RunRecursiveAjaxCalls(i + 1);
            });
    }

    function RecursiveLoadListItems(index, items, targetElement, showAdditionalFields) {
        if (index >= items.length) {
            $(".site-footer").fadeIn('slow');
            $(".site-main.site-main--interior").fadeIn('slow');
            $(".loading-image").hide();
            return;
        }

        var ajaxUrl = "/Layouts/WebUserControls/Main/Insights/AjaxLoadListItem.aspx?guid=" + items[index];
        if (showAdditionalFields)
            ajaxUrl += '&showadditionalfields=true';

        $.ajax({ url: ajaxUrl })
            .done(function (p) {
                $(targetElement).append(p);
                RecursiveLoadListItems(index + 1, items, targetElement, showAdditionalFields);
            });
    }

    function UpdateTitleTag(tab) {
        var titleTag;
        var titleTagParts = $("head title").text().split("|");
        var namePart = titleTagParts[0];
        if (titleTagParts[0].indexOf("-") != -1)
            namePart = titleTagParts[0].substring(0, titleTagParts[0].indexOf("-"));
        if (tab !== undefined && tab !== 'undefined')
            namePart = namePart + " - " + tab;
        titleTag = namePart;
        for (i = 1; i < titleTagParts.length; i++) {
            titleTag = titleTag + " | " + titleTagParts[i];
        }
        $("title").text(titleTag.replace(" and ", " & ").replace("&amp;", "&"));
    }

    function BindTranslationClick() {
        $(".translation").click(function () {
            translationGuid = $(this).attr("data-translation-guid");
            LoadTab(1, translationGuid);
        })
    }

    function BindAttorneyFilters() {
        $(".filtering__action.title").click(function () {
            sortField = "title";
            currentProfessionalsPage = 1;
            professionalsPageCount = parseInt($("#hiddenPageCount").text());
            $(".listing.professional-results").html("");
            $(".filtering__action").removeClass("is-active");
            $(this).addClass("is-active")
            LoadProfessionals();
        })

        $(".filtering__action.name").click(function () {
            sortField = "name";
            currentProfessionalsPage = 1;
            professionalsPageCount = parseInt($("#hiddenPageCount").text());
            $(".listing.professional-results").html("");
            $(".filtering__action").removeClass("is-active");
            $(this).addClass("is-active")
            LoadProfessionals();
        })

        $(".btn-accordion.professional").click(function () {
            LoadProfessionals();
        })
    }

    function BindAccordion() {
        $('.accordion').click(function () {
            var $this = $(this),
                $list = $this.find('.accordion__list'),
                $active = $('.js-is-active .accordion__list');

            ($active.length > 0) ?
                $('.js-is-active .accordion__list').slideUp(function () {
                    if (!$this.hasClass('js-is-active')) {
                        $('.accordion').removeClass('js-is-active');
                        $this.addClass('js-is-active');
                        $list.slideDown();
                    }
                    else $this.removeClass('js-is-active');
                }) :
                $list.slideDown(function () { $this.addClass('js-is-active'); });
        });
    }

    function BindMasonry() {
        var container = document.querySelector('.tab-wrapper.col--main.col--main--reverse');
        if (!!container) {
            imagesLoaded(container, function () {
                $(".masonry-board").each(function () {
                    var secondContainer = $(this).get(0);

                    if (!!secondContainer) {
                        var msnry = new Masonry(secondContainer, {
                            "gutter": secondContainer.querySelector('.gutter-sizer'),
                            "itemSelector": '.box',
                            "columnWidth": secondContainer.querySelector('.grid-sizer'),
                        });
                    }
                })
            });
        };
    }
});